import { useMemo } from "react";
import { IOption } from "components/MainSelect/MainSelectInterfaces";
import { useTranslation } from "react-i18next";
import { IRCAAPComplianceFilters } from "./RCAAPComplianceFiltersInterfaces";

const useRCAAPComplianceFilters = ({ rcaComplianceRangeOptions }: IRCAAPComplianceFilters) => {
    const { t } = useTranslation();

    const rcaComplianceOptions: IOption[] = useMemo(
        () =>
            rcaComplianceRangeOptions.map((value) => ({
                id: value,
                name: t(`rca.compliance.filters.period`, { period: value }),
            })),
        [t, rcaComplianceRangeOptions],
    );

    return {
        rcaComplianceOptions,
    };
};

export default useRCAAPComplianceFilters;
